import FormHelper from '../../../shared/helpers/FormHelper';

export default class BannerFormHelper extends FormHelper {}
